module.exports = __webpack_public_path__ + "img/quizz-step-6-4.a45bc6d7.jpg";